import {alias, createModelSchema, reference} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";


export class AdPlacement extends BaseObject {

    static schema() {
        return reference("uid", (uid, cb) => {
            return cb(null, RedactorUtils.getAdPlacement(uid));
        });
    }

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._reward = null;
        this._multiplier = 0;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get multiplier() {
        return this._multiplier;
    }

    set multiplier(value) {
        this._multiplier = value;
    }

    valid() {

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (!Number.isInteger(this.multiplier) || this.multiplier < 0) {
            return false;
        }

        return true;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new AdPlacement());
        } else if (target instanceof AdPlacement) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(AdPlacement, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _reward: alias("reward", RewardModel.schema()),
    _multiplier: alias("multiplier", Schema.primitive())
});